import { useSelector } from 'react-redux';
import { useAuthTenant } from 'store/auth';
import { Container } from 'Components/Container';
import { Information } from 'Components/Information';
import React, { useMemo } from 'react';
import { DefaultTable } from '../../Components/DefaultTable';
import { tableHeader } from './table-header.js';
import { useQueries } from 'react-query';
import { getGapAnalysis } from 'services/gap-analysis';
import { PageHelper } from 'Components/PageHelper';
import { useTranslation } from 'react-i18next';

export const GapAnalysis = () => {
  const { t } = useTranslation(['gap-analysis', 'common']);
  const selectedTenant = useSelector(useAuthTenant);

  const tourSteps = useMemo(() => [
    {
      target: 'body',
      content: t('gap-analysis:tour.list.step0'),
      disableBeacon: true,
      disableScrolling: true,
      placement: 'center',
    },
    {
      target: '[data-tour="page-title"]',
      content: t('gap-analysis:tour.list.step1'),
      disableScrolling: true,
    },
    {
      target: '[data-tour="add-button"]',
      content: t('gap-analysis:tour.list.step2'),
      disableScrolling: true,
    },
    {
      target: '[data-tour="info-card"]',
      content: t('gap-analysis:tour.list.step3'),
      disableScrolling: true,
    },
    {
      target: '[data-tour="table"]',
      content: t('gap-analysis:tour.list.step4'),
      disableScrolling: false,
    },
    {
      target: 'body',
      content: t('gap-analysis:tour.list.step5'),
      disableScrolling: true,
      placement: 'center',
    },
  ], [t]);

  const results = useQueries([
    {
      queryKey: ['companyKey', selectedTenant._id],
      queryFn: () => getGapAnalysis(selectedTenant._id),
      enabled: !!selectedTenant._id, // Só busca se houver um ID válido
    },
  ]);
  const gapAnalysisData = results[0].data?.data || [];

  return (
    <Container
      title={t('gap-analysis:page.title')}
      breadcrumb={t('gap-analysis:page.breadcrumb')}
      showButtonAdd
      linkPage="/gap-analysis"
      data-tour="page-title"
      addButtonDataTour="add-button"
    >
      <div data-tour="info-card">
      <Information
        title={t('gap-analysis:page.info.title')}
        description={<p className="m-0">{t('gap-analysis:page.info.description')}</p>}
        style={{
          marginTop: '24px',
          marginBottom: '24px',
        }}
      />
      </div>
      <div data-tour="table">
      <DefaultTable applyMB rows={tableHeader(t)} cells={gapAnalysisData} hideEdit hideDelete showDashboard={true} link="gap-analysis" />
      </div>
      <PageHelper steps={tourSteps} tourKey="gap-analysis-list" />
    </Container>
  );
};
